import { Component, ElementRef, Input, Output, EventEmitter, OnInit, Inject } from '@angular/core';
import {Config} from '../config';
import {NgStyle} from '@angular/common';
import {Jsonp, Http, Headers, URLSearchParams, Response, RequestOptions } from '@angular/http';
import {ParcelReportService} from '../tools/parcelReport.service';
import { MapService } from '../map-view/map.service';
import { EventsService } from '../EventsService';
import { EsriTasksService } from '../esriTasks/esriTasks-service';
import Geometry = require('esri/geometry/Geometry');

declare let componentHandler: any;

@Component({
    selector: 'parcel-report',
    template: require('./parcelReport.component.html')
})

export class ParcelReportComponent implements OnInit  {
 
    @Input() emailSubject:string;
    @Input() emailBody:string;
    @Output() displayStatus = new EventEmitter<boolean>();


    //General state/admin variables
    error: any;
    appSettings: Object;

    //email
    toAddress:string;
    fromAddress:string; 
    message:Object;
    isDisplayed:boolean = false;
    showParcelSearchResult:boolean = false;
    foundParcelResult:string = "";
    private parcelFeature:any;
    selectedParcelNumber:string;
    private showCreateButton:boolean = false;

    private jsonpCallback:string = "?method=JSONP_CALLBACK";
    _parcelReportService:ParcelReportService;

    loadingImage:string = "./images/loading.gif";
    reportGenerating:boolean = false;

    //  inject necessary services
    constructor(private elRef: ElementRef, private http: Http, private _mapService: MapService, private _eventsService:EventsService, private _esriTasksService:EsriTasksService, @Inject(ParcelReportService) prs) { 
        this._parcelReportService = prs;
    }

    //initialize email objects 
    ngOnInit () {
        this.appSettings = Config.config[0];
        //update chnages in the DOM
        componentHandler.upgradeAllRegistered();
    }

    // destroy 
    ngOnDestroy() {

    }

    addressLocationPicked(pickedAddressLocation:object){
        console.log(pickedAddressLocation);
        let parcelNumber:string = "";
        try{
            if(pickedAddressLocation["addressSuggestion"]["SuggestionType"] == "ParcelNumber"){
                parcelNumber = pickedAddressLocation["addressSuggestion"]["FullName"];
            }else if(pickedAddressLocation["addressSuggestion"]["SuggestionType"] == "Address"){
                parcelNumber = pickedAddressLocation["addressLocation"]["ParcelNumber"];
            }
            if(parcelNumber && parcelNumber != ""){
                this.foundParcelResult = "Parcel # " + parcelNumber + ". To generate report for this parcel, click \"CREATE\" button.";
                this.showParcelSearchResult = true;
                this.showCreateButton = true;
                this.selectedParcelNumber = parcelNumber;
                this.reportGenerating = false;
            }else{
                this.foundParcelResult = "Cannot find parcel number. Please check the address or parcel number you entered.";
                this.showParcelSearchResult = true;
                this.showCreateButton = false;
                this.reportGenerating = false;
            }
        }catch(ex){
            this.foundParcelResult = "Cannot find parcel number. Please check the address or parcel number you entered";
            this.showParcelSearchResult = true;
            this.showCreateButton = false;
        }
    }
    
    createReport(){
        this._esriTasksService.queryFeatures(this.appSettings["ParcelReport"]["ParcelsQueryMapService"], null, ("PARCEL_C = '" + this.selectedParcelNumber + "'"), ["PARCEL_C", "STNUMBER", "PRE_DIR", "FULL_STNAME", "CITY", "STATE", "ZIPCODE"], true, null).then(results => {
            var parcelAttrs:object = results.features[0].attributes;
            var fullAddress:string = parcelAttrs["STNUMBER"] + " " + ((parcelAttrs["PRE_DIR"] == null) ? "" : (parcelAttrs["PRE_DIR"] + " "))  + parcelAttrs["FULL_STNAME"] + " " + parcelAttrs["CITY"] + ", " + parcelAttrs["STATE"] + " " + parcelAttrs["ZIPCODE"];
            var parcelNumber = parcelAttrs["PARCEL_C"];
            var parcelFeature:any = results.features[0];
            parcelFeature["attributes"] = {
                "Parcel Address":fullAddress,
                "Parcel Number":parcelNumber
            };
            this._parcelReportService = new ParcelReportService(this._esriTasksService, this._mapService, this._eventsService);
            this._parcelReportService.activeProject.subscribe(thing => 
                {
                    if(thing["status"] != "ready"){
                        alert("Report creation for parcel " + thing["parcelNumber"] + " has failed. Please try again later or contact the application support team if the issue repeats.");
                        if(this.selectedParcelNumber == thing["parcelNumber"]){
                            this.foundParcelResult = "Parcel # " + parcelNumber + ". To generate report for this parcel, click \"CREATE\" button.";
                            this.showParcelSearchResult = true;
                            this.showCreateButton = true;
                            this.reportGenerating = false;
                        }
                    }else if(thing["status"] == "ready"){
                        if(this.selectedParcelNumber == thing["parcelNumber"]){
                            this.foundParcelResult = "Parcel # " + parcelNumber + ". To generate report for this parcel, click \"CREATE\" button.";
                            this.showParcelSearchResult = true;
                            this.showCreateButton = true;
                            this.reportGenerating = false;
                        }
                    }
                }
            );
            this.reportGenerating = true;
            this.showCreateButton = false;
            this.foundParcelResult = "Report generation is in progress. The report will open in a new browser tab when it is ready. While it is being generated, you can search and generate a report for another parcel."
            this._parcelReportService.startParcelReport(parcelFeature);
        }, error => {
            this.foundParcelResult = "Cannot find parcel number. Please check the address or parcel number you entered.";
            this.showParcelSearchResult = true;
            this.reportGenerating = false;
            this.showCreateButton = false;
        });
    }

    addressSuggestionsReceived(event){
        this.showParcelSearchResult = false;
    }

    //emit the event telling the parent component to show the panel
    showPanel() {
        //this.isDisplayed = true;
        this.displayStatus.emit(true)
    }
    
    //emit the event telling the parent component to hide the panel
    closePanel() {
       this.displayStatus.emit(false)
    }
}


// WEBPACK FOOTER //
// ./app/tools/parcelReport.component.ts